import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import MyModal from 'helpers/MyModal.js';
import React, { useEffect, useState } from 'react';
import TiposStatusTable from './_TiposStatusTable.js';
import EditTipoStatus from './_EditTipoStatus.js';
const URI = ApiEndpoint + 'configuration/';

const TiposStatus = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [openModal, setOpenModal] = useState(false);
  const [tiposStatus, setTiposStatus] = useState(false);

  const [idTipoStatusEdit, setIdTipoStatusEdit] = useState(false);

  const handleClose = () => {
    setOpenModal(false);
    getTiposStatusList();
  };
  const getTiposStatusList = async () => {
    console.log('entre a getCitiesList');
    setTiposStatus(null);

    httpClient('GET', URI + 'tiposstatus/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setTiposStatus(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };
  useEffect(() => {
    getTiposStatusList();
  }, []);

  return (
    <>
      {tiposStatus && (
        <TiposStatusTable
          tiposstatus={tiposStatus}
          setIdTipoStatus={setIdTipoStatusEdit}
          setOpenModa={setOpenModal}
          setOpenModal={setOpenModal}
        ></TiposStatusTable>
      )}
      {/* {openConfirm && (
          <ConfirmAction
            message={'Desea eliminar el registro?'}
            title={'Confirmacion'}
            handleClose={handleCloseConfirm}
            open={openConfirm}
            ConfirmAction={DeleteConfirmed}
          ></ConfirmAction>
        )} */}
      {openModal && (
        <MyModal
          id="id_myModal"
          title={
            (idTipoStatusEdit > 0 ? 'Editar' : 'Agregar') + ' Tipos de Status'
          }
          openModal={openModal}
          closeModal={handleClose}
        >
          <EditTipoStatus
            closeModal={handleClose}
            idTipoStatus={idTipoStatusEdit}
          ></EditTipoStatus>
        </MyModal>
      )}
    </>
  );
};

export default TiposStatus;
